import { render, staticRenderFns } from "./CounselingQuestions.vue?vue&type=template&id=f2b4036a&scoped=true&lang=pug&"
import script from "./CounselingQuestions.vue?vue&type=script&lang=ts&"
export * from "./CounselingQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./CounselingQuestions.vue?vue&type=style&index=0&id=f2b4036a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b4036a",
  null
  
)

export default component.exports